import { AxiosError } from "axios";
import { useQuery } from "react-query";
import { authAxios as axios } from "api-generate-types/src/axios";
import { config } from "config";

export function useGetIgApiAuthUrl(profileId?: string) {
  return useQuery<string, AxiosError>(["instagramAuthLink", profileId], {
    queryFn: async () => {
      const { data } = await axios.post(
        `${config.profileApiUrl}/profiles/${profileId}/social/instagram/start`
      );

      return data.url;
    },
    cacheTime: 0,
  });
}
